import { render, staticRenderFns } from "./Mental_health_report.vue?vue&type=template&id=6a047093"
import script from "./Mental_health_report.vue?vue&type=script&lang=js"
export * from "./Mental_health_report.vue?vue&type=script&lang=js"
import style0 from "./Mental_health_report.vue?vue&type=style&index=0&id=6a047093&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports